import { useCohortListQuery } from '@verantos-dev/data-access-cohorts';

import { useAdRouteParams } from './useAdRouteParams';
import { selectCohorts } from '../state/selectors';
import { useAnalyticalDatasetDefinitionStore } from '../state/useAnalyticalDatasetDefinitionStore';
import type { UseSelectedSourceCohortResult } from '../types';

// Fires as soon as `projectId` is known (not gated on a current cohort
// selection) so the AddCohortPickerModal opens against a warm cache.
export const useSelectedSourceCohort = (): UseSelectedSourceCohortResult => {
  const { projectId } = useAdRouteParams();

  const cohorts = useAnalyticalDatasetDefinitionStore(selectCohorts);
  const cohortProfileId = cohorts[0]?.cohortProfileId ?? null;

  const { data: cohortList, isLoading: isCohortListLoading } = useCohortListQuery({
    projectId,
    enabled: Boolean(projectId),
  });

  const selectedCohort =
    cohortProfileId && cohortList
      ? cohortList.find((c) => c.cohortProfileId === cohortProfileId) ?? null
      : null;

  return {
    cohortProfileId,
    selectedCohort,
    isCohortListLoading,
  };
};
